import { toTimestampValue } from "./relativeTime";

function normalizeTimestampCandidate(value) {
  if (value === null || value === undefined || value === "") return "";

  if (typeof value === "number" && Number.isFinite(value) && value > 0) {
    return value;
  }

  const text = String(value).trim();
  if (!text) return "";

  return toTimestampValue(text) > 0 ? text : "";
}

function pickFirstTimestampValue(row = {}, keys = []) {
  for (const key of keys) {
    const candidate = normalizeTimestampCandidate(row?.[key]);
    if (candidate !== "") return candidate;
  }

  return "";
}

export function getEntityLastSyncValue(row = {}) {
  return pickFirstTimestampValue(row, [
    "lastSyncAt",
    "last_sync_at",
    "last_sync",
    "lastSync",
  ]);
}

export function getEntityLastActivityValue(row = {}) {
  return pickFirstTimestampValue(row, [
    "lastActivityAt",
    "last_activity_at",
    "last_activity_time",
    "lastActivityTime",
    "last_activity_date",
    "lastActivityDate",
  ]);
}

export function getEntityLastActivityType(row = {}, { emptyValue = "-" } = {}) {
  return [row?.last_activity_type, row?.lastActivityType, row?.last_activity, row?.lastActivity]
    .map(value => String(value ?? "").replace(/\s+/g, " ").trim()).find(Boolean) || emptyValue;
}

export function getCompanyLastActivityType(row = {}) {
  return (
    getEntityLastActivityType(row, { emptyValue: "" }) ||
    "Company created"
  );
}
